import React from 'react';
import './Faq.css';
import { Collapse,Col, Row, } from 'antd';
import { FormattedMessage } from 'react-intl';

const { Panel } = Collapse;

function Faq(){
    return(
        <div className="faq-container">
            <div className="faq-title"><FormattedMessage id="faq-title"/></div>
            <div className="sub-faq-title"><FormattedMessage id="sub-faq-title"/></div>
            <br/>
            <Row gutter={[16, 32]} justify="center">
                <Col xs={24} sm={4} md={8} lg={8} xl={12}>
                    <Collapse expandIconPosition="right" className="collapse">
                        <Panel header={<FormattedMessage id="panel-header1"/>} key="1" className="panel_header">
                            <div className="panel_content">
                                <FormattedMessage id="panel-content1"/>
                            </div>
                        </Panel>
                    </Collapse>
                    <Collapse expandIconPosition="right" className="collapse">
                        <Panel header={<FormattedMessage id="panel-header2"/>} key="2" className="panel_header">
                            <div className="panel_content">
                                <FormattedMessage id="panel-content2"/>
                                <a href="/APIs" className="link_api">APIs</a>.
                            </div>
                        </Panel>
                    </Collapse>
                </Col>
                <Col xs={24} sm={4} md={8} lg={8} xl={12} className="second-group">
                    <Collapse  expandIconPosition="right" className="collapse">
                        <Panel header={<FormattedMessage id="panel-header3"/>} key="3" className="panel_header">
                            <div className="panel_content">
                                <FormattedMessage id="panel-content3"/>
                            </div>
                        </Panel>
                    </Collapse>
                    <Collapse expandIconPosition="right" className="collapse">
                        <Panel header={<FormattedMessage id="panel-header4"/>} key="4" className="panel_header">
                            <div className="panel_content">
                                <FormattedMessage id="panel-content4"/>
                            </div>
                        </Panel>
                    </Collapse>
                </Col>
            </Row>
        </div>
    )
}

export default Faq;